import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;
export const Suport = styled.a`
  position: fixed;
  top: 80%;
  left: -70px; /* escondido para fora da tela */
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 16px;

  background: #1f2937;
  color: #fff;

  padding: 12px 16px;
  border-radius: 0 8px 8px 0; /* invertido */

  font-size: 14px;
  font-weight: 500;
  text-decoration: none;

  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition:
    left 0.3s ease,
    background 0.2s;

  &:hover {
    left: 0; /* desliza para dentro */
    color: #fff;
    text-decoration: none;
    background: #111827;
  }

  svg {
    font-size: 23px;
  }
`;